import axios from 'axios';
import { ABOUTURL } from '../index';

export const getAboutApi = (postData) => {
  return axios.post(ABOUTURL, JSON.stringify(postData));
};
